import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";

export default function Content({ data, reportData, entity, title, printComponentRef, setIsPrinting }) {
    return (
        <>
            {reportData && data && (
                <PrintTemplate
                    entity={entity}
                    title={title}
                    ref={printComponentRef}
                    setIsPrinting={setIsPrinting}
                >
                    <div className="transform !-translate-y-[8.5px]" />
                    <div className="w-full mt-[25px] print:mt-0">
                        <ReportContent data={reportData} />
                    </div>
                </PrintTemplate>
            )}
        </>
    )
}